import React from 'react';
import classNames from 'classnames';
import { StatusIcon } from './StatusIcon';
import { MDFPopover } from './MDFPopover';
import { OverlayTrigger2 } from './OverlayTrigger2';
import { Popover2 } from './Popover2';
import { FormatHelper } from '@adp-wfn/mdf-core';

export interface IStatusOverlay {
  // Accessibility: aria-label for the popover trigger. Defaults to status type if none is provided.
  buttonAriaLabel?: string;

  // support popover children from the application
  children?: any;

  // className to support styles
  className?: any[];

  // class to be applied for the icons
  iconClass?: string;

  // Size of the statusIcon
  size?: 'sm' | 'md';

  // choose one of the statusType to show the overlay.
  statusType?: 'success' | 'info' | 'warning' | 'error';
}

export function MDFStatusOverlay(props: any) {
  const renderPopover = () => {
    let popover: any;

    React.Children.forEach(props.children, (child: any): any => {
      if (child.type === MDFPopover) {
        popover = child;
      }
    });

    return (
      popover ?
        <Popover2 id={'popoverOverlay'} {...popover.props} className={`mdf-overlay-popover vdl-popover--${props.statusType || ''}`}>
          {popover.props.children && popover.props.children}
        </Popover2> : null
    );
  };

  const renderCircleIcon = () => <StatusIcon size={props.size} className={classNames(props.className)} statusType={props.statusType} />;

  // Set button aria-label as custom label if buttonAriaLabel property is provided
  let statusButtonAriaLabel;

  if (props.buttonAriaLabel) {
    statusButtonAriaLabel = props.buttonAriaLabel;
  }
  // Set button aria-label as status type
  else if (props.statusType === 'success') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@LBL_SUCCESS');
  }
  else if (props.statusType === 'info') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@LABEL_INFO');
  }
  else if (props.statusType === 'warning') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@label_warning');
  }
  else if (props.statusType === 'error') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@Error');
  }
  else if (props.statusType === 'delegate') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@label_newhirerefresh_delegatelabel');
  }
  else if (props.statusType === 'notStarted') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@Label_Not_Started');
  }
  else if (props.statusType === 'inProgress') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@InProgress');
  }
  else if (props.statusType === 'submitted') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@batch_progress_submitted');
  }
  else if (props.statusType === 'inReview') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@TD_LB_IN_REVIEW');
  }
  else if (props.statusType === 'approved') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@Approved');
  }
  else if (props.statusType === 'accepted') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@label_accepted');
  }
  else if (props.statusType === 'completed') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@CompletedStatus');
  }
  else if (props.statusType === 'inComplete') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@Incomplete');
  }
  else if (props.statusType === 'archived') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@archiveEmployee_Archived');
  }
  else if (props.statusType === 'generalLiability') {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@GENERAL_LIABILITY');
  }
  // If no custom aria-label or recognized status type is provided, default to this label
  else {
    statusButtonAriaLabel = FormatHelper.formatMessage('@@MoreInformation');
  }

  // wrap circleIcon with the div to render the popover on the div
  // When no popover child is passed render only the circleIcon
  return (
    renderPopover() ?
      <OverlayTrigger2
        trigger={['hover', 'focus', 'click']}
        placement={'bottom'}
        overlay={renderPopover()}
      >
        <div role="button" tabIndex={0} aria-label={statusButtonAriaLabel}>
          {renderCircleIcon()}
        </div>
      </OverlayTrigger2> :
      <div tabIndex={0}>
        {renderCircleIcon()}
      </div>
  );
}
